import { Container, Row, Col } from "react-bootstrap";
import { FaGraduationCap, FaBriefcase, FaMedal } from "react-icons/fa";

function Experience() {
  return (
    <>      <Container fluid className="experience-section">
        <Container>
          <Row className="mb-5">
            <Col md={12}>
              <h2 className="experience-heading text-center mb-4">
                <FaGraduationCap className="purple" /> Education
              </h2>
              <div className="experience-grid">
                <div className="experience-card">
                  <h3>Master of Business Administration</h3>
                  <p className="company">Ravindra Nath Tagore University</p>
                  <p>HR & IT Specialization</p>
                  <p>First Division with 66.80%</p>
                  <p className="year">2018-2020</p>
                </div>

                <div className="experience-card">                  <h3>Master of Computer Application</h3>
                  <p className="company">St. Xavier's College, Ranchi</p>
                  <p className="gold-text">
                    <FaMedal style={{ marginRight: "8px", fontSize: "1.2em" }} />
                    Gold Medalist
                  </p>
                  <p>82.6% Aggregate</p>
                  <p className="year">2014-2017</p>
                </div>

                <div className="experience-card">
                  <h3>Bachelor of Computer Application</h3>
                  <p className="company">Ranchi University, Ranchi</p>
                  <p>First Division</p>
                  <p>72% Aggregate</p>
                  <p className="year">2010-2013</p>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <h2 className="experience-heading text-center mb-4">
                <FaBriefcase className="purple" /> Work Experience
              </h2>
              <div className="experience-grid">
                <div className="experience-card">
                  <h3>Senior Technical Consultant</h3>
                  <p className="company">IzzkiTech Solutions</p>
                  <p className="year">Aug 2024 - Present</p>
                </div>

                <div className="experience-card">
                  <h3>Technical Lead</h3>
                  <p className="company">GrowExx, Ahmedabad</p>
                  <p className="year">Oct 2023 - July 2024</p>
                </div>

                <div className="experience-card">
                  <h3>Team Lead</h3>
                  <p className="company">Nathcorp Pvt. Ltd. Ranchi</p>
                  <p className="year">September 2017 - Oct 2023</p>
                </div>

                <div className="experience-card">
                  <h3>Software Developer</h3>
                  <p className="company">OBPS, Ranchi</p>
                  <p className="year">July 2013 - June 2014</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Experience;
